import i18n from '@geek/yum-freight-framework/src/lang/index'
import zh_CN from './locales/zh_CN'
import en from './locales/en'

const projectLocales = { zh_CN, en }

function withProjectMsg(locale, message) {
  const localeMessages = projectLocales[locale]
  if (!localeMessages || !message || typeof message !== 'object') {
    return message
  }
  return {
    ...message,
    msg: { ...(message.msg || {}), ...localeMessages }
  }
}

let originalSetLocaleMessage = null

export function initProjectI18n() {
  if (!originalSetLocaleMessage) {
    originalSetLocaleMessage = i18n.setLocaleMessage.bind(i18n)
    i18n.setLocaleMessage = (locale, message) => {
      originalSetLocaleMessage(locale, withProjectMsg(locale, message))
    }
  }

  Object.keys(projectLocales).forEach((code) => {
    const current = i18n.getLocaleMessage(code) || {}
    i18n.setLocaleMessage(code, current)
  })
}

export { i18n }
